(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('pieSection', pieSection);

    /* @ngInject */
    function pieSection($timeout, $sce, $animate) {
        var directive = {
            bindToController: true,
            templateUrl: 'pie-section.tpl',
            controller: pieSectionController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '=',
                sections: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.colNum = 0;
            angular.forEach(scope.vm.sections, function(section, sidx) {
                scope.vm.sections[sidx]['columns-class'] = '';
                scope.vm.sections[sidx]['additional-options'] = [];
                angular.forEach(section.columns, function(column, cidx) {
                    /*
                    if (!column) {
                        return;
                    }
                    */
                    //section.columns[cidx] = {'col-classes' : []};
                    section.columns[cidx]['col-classes'] = [];
                    if(!angular.isUndefined(column.width) && !angular.isUndefined(column.image)) {
                        section.columns[cidx]['col-classes'].push(column.width.value);
                        section.columns[cidx]['col-classes'].push('image-holder');
                        // console.log('both');
                    } if(!angular.isUndefined(column.width) && angular.isUndefined(column.image)) {
                        section.columns[cidx]['col-classes'].push(column.width.value);
                        // console.log('width');
                    } if(angular.isUndefined(column.width) && !angular.isUndefined(column.image)) {
                        section.columns[cidx]['col-classes'].push('image-holder');
                        // console.log('image-holder');
                    }
                    scope.vm.colNum += 1;
                    if(!angular.isUndefined(column.video) && column.video.value != "") {
                        scope.vm.getUrl = function (id) {
                            return '//www.youtube.com/embed/' + id + '?rel=0';
                        };
                        section.columns[cidx].youtube = $sce.trustAsHtml('<iframe width="560" height="315" src="' + scope.vm.getUrl(column.video.value) + '" frameborder="0" allowfullscreen></iframe>');
                    }
                });
                scope.vm.sections[sidx]['columns-class'] = 'columns-' + scope.vm.colNum;
                scope.vm.colNum = 0;
                if(Object.keys(section.options).length > 0) {
                    var keys = Object.keys(section.options);
                    for(var i = 0, l = keys.length; i < l; i++) {
                        if(section.options[keys[i]] == true) {
                            scope.vm.sections[sidx]['additional-options'].push(keys[i]);
                        }
                    }
                }

                if(section.type.value == "sponsors") {
                    scope.vm.activeSlide = 0;

                    scope.$on('debouncedResize', function(e, args) {
                        scope.vm.elWidth = element.find('.slider-inner').width() / 4;
                        scope.vm.trackWidth = scope.vm.elWidth * section.sponsors.length;
                        // var sponsorsSliderStyles = document.getElementById('sponsors-slider');
                        // if(!sponsorsSliderStyles) {
                        //     sponsorsSliderStyles = document.createElement('style');
                        //     sponsorsSliderStyles.id = 'sponsors-slider';
                        //     document.head.append(sponsorsSliderStyles);
                        // }
                        // sponsorsSliderStyles.innerHTML = ".sponsors-slider .slider-inner .slider-track { left: -" + scope.vm.elWidth + "px; }" +
                        //     ".sponsors-slider .slider-inner .slider-track.move-left { left: -" + (scope.vm.elWidth * 2) + "px; }";
                    });

                    $timeout(function () {
                        // scope.vm.elWidth = element.find('.slider-inner').width() / 4;
                        // scope.vm.trackWidth = scope.vm.elWidth * section.sponsors.length;
                        scope.$broadcast('debouncedResize', null);
                    });

                    scope.vm.backward = function() {
                        var spliced = section.sponsors.splice(section.sponsors.length - 1, 1);
                        section.sponsors = spliced.concat(section.sponsors);
                    };

                    scope.vm.forward = function() {
                        var spliced = section.sponsors.splice(0, 1);
                        section.sponsors = section.sponsors.concat(spliced);
                    };

                    scope.vm.prevSlide = function() {
                        scope.vm.backward();
                        // $animate.addClass(element.find('.slider-track'), 'move-left').then(function() {
                        //     console.log('move-left was done');
                        //     element.find('.slider-track').removeClass('move-left');
                        // });
                    };

                    scope.vm.nextSlide = function() {
                        scope.vm.forward();
                        // $animate.addClass(element.find('.slider-track'), 'move-right').then(function() {
                        //     console.log('move-right was done');
                        //     element.find('.slider-track').removeClass('move-right');
                        // });
                    };

                }

            });

            angular.forEach(scope.vm.sections, function(section, sidx) {
                angular.forEach(section.columns, function(column, cidx) {
                    if (section.type.value == 'default') {
                        if (column.description.value.indexOf('iframe') != -1) {
                            column.description_trusted = $sce.trustAsHtml(column.description.value);
                        }
                    }
                });
            });

        }
    }

    /* @ngInject */
    function pieSectionController ($scope) {
        // function setup() {
        //     var rootElStyle = rootElement.currentStyle || window.getComputedStyle(rootElement), customStyles = document.createElement('style')
        //     document.head.append(customStyles);
        //     var marginTop = rootElStyle.getPropertyValue("margin-top");
        //     customStyles.innerHTML = ".toppanel.fixed { top: " + marginTop + "; }" +
        //         // ".mobileribbon.fixed { top: " + marginTop + "; }" +
        //         "header { top: " + marginTop + "; }";
        // }

        $scope.startPreloader = function(e) {
            if (/sellers\/?/.test(e.target.getAttribute('href'))) {
                $scope.animatePreloader(e.target, true);
            }
            if (/\.\w{3,4}$/.test(e.target.getAttribute('href'))) {
                e.target.setAttribute('target', '_self');
            }
        };

        $scope.animatePreloader = function(el,start) {
            if (start) {
                var preloader = angular.element('<div class="button-holder button-center"><div class="form-success-msg" style="display:contents;"></div></div>').insertBefore(angular.element(el).parent());
                $scope.vm.preloader = '...';
                $scope.vm.pTimer = setInterval(function() {
                    if ($scope.vm.preloader.length == 3) {
                        $scope.vm.preloader = '';
                    } else {
                        $scope.vm.preloader += '.';
                    }
                    preloader.find('.form-success-msg').text('Loading ' + $scope.vm.preloader);
                }, 500);
            } else {
                clearInterval($scope.vm.pTimer);
            }
        };

    }
})();